import UpdateOffer from "../../features/dashboard/offers/UpdateOffer"

function UpdateOffersDB() {
    return <UpdateOffer />
}

export default UpdateOffersDB